module.exports = __webpack_public_path__ + "media/fr-PartagezCeSite.1a9718c6.mp3";